export default __webpack_public_path__ + "static/media/main-logo.b18aa1b3.png";